





















































import { Component, Vue } from 'vue-property-decorator'

@Component

export default class ComponentModalSolicitacaoCirurgiaMedicoPendencia extends Vue {
  files: any[] = []
  messages: any[] = []
  message: String = ''

  answerMessage() {
    const m = {
      descricao: this.message,
    }

    this.messages.push(m)
    this.message = ''
  }

  removeItemPendente(message) {
    const removeArray: any[] = []

    for (let i = 0; i < this.messages.length; i++) {
      if (this.messages[i].descricao === message.descricao) {
        removeArray.push(i)
      }
    }

    for (let i = 0; i < removeArray.length; i++) {
      this.messages.splice(removeArray[i], 1)
    }
  }

  removeFile(file) {
    const removeArray: any[] = []
  }
}

